export default {
  namespaced: true,
  state: {
    facultyData: {
      creator_id: '',
      creator_name: '',
      faculty_name: '',
      grade_name: '',
      id: '',
      major_level: '',
      major_name: '',
      pub_status: '',
      updated_at: "1629101692"
    },
  },
  mutations: {
    saveFacultyData(state, payload) {
      state.facultyData = {...payload}
    },
  },
  actions: {},
}
